<!-- eslint-disable max-lines -->
<template>
    <div class="fail-manage">
        <Paper class="fail-manage-paper">
            <list-layout-paper>
                <template slot="header-search" class="searchBox">
                    <search-box
                        ref="searchBox"
                        :search-key="config.name"
                        :fields="config.searchFields"
                        :showResetBtn="true"
                        @search-change="ApiFailList.searchList"
                    />
                </template>
                <template slot="header-button">
                    <lotsButton
                        type="primary"
                        size="mini"
                        title="导出">
                        <report-export
                            #default="{ submit }"
                            reportCode="LCRM_ANOMALY_RECORD_DATA_SET">
                            <span @click="handleExport(submit)">导出</span>
                        </report-export>
                    </lotsButton>
                    <lotsButton
                        type="primary"
                        size="mini"
                        title="刷新"
                        @click="refresh"
                        plain>
                        <span class="icon iconfont icon-refresh"></span>
                    </lotsButton>
                    <el-tooltip effect="dark" :content="'列配置'" placement="bottom">
                        <el-button
                        icon="iconfont icon-list_install"
                        type="primary"
                        size="mini"
                        :title="'列配置'"
                        @click="showColumnConfigDialog"
                        plain />
                    </el-tooltip>
                </template>
                <!-- 表格 -->
                <template v-slot:list="{ tableHeight }">
                    <table-box
                        ref="clientOrder"
                        :height="tableHeight"
                        v-loading="ApiFailList.tableLoading"
                        :selection="config.selection"
                        :index="config.index"
                        :columns="config.tableData.columns"
                        :rows="ApiFailList.totalData"
                        :actions="config.actions"
                        >
                        <template v-slot:col-append="{ col, row }">
                            <div v-if="col.prop === 'businessType'">{{col.prop === 'businessType' ? row.busiLabelList : row.businessType}}</div>
                        </template>
                    </table-box>
                </template>
                <template slot="footer">
                    <lots-pagination
                        @size-change="ApiFailList.sizeChange"
                        :current-page.sync="ApiFailList.pageNo"
                        @current-change="ApiFailList.pageChange"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="ApiFailList.pageTotal" >
                    </lots-pagination>
                </template>
            </list-layout-paper>

            <!-- 表格列配置弹框 -->
            <column-config
                :pageID="config.name"
                :initColumns="config.tableData.columns"
                ref="otpColumnConfig"
                @header-change="config.tableData.columns = $event"
            />

        </Paper>
    </div>
</template>
<script>
import { ref, reactive, onMounted } from '@vue/composition-api';
import { failRecordList } from '@mdm/api/basicSettings/failList.js';
import { AdvanceListClass } from '@/modules/mdm/composition/dc/common/list/AdvanceListClass';
import { config as configStatic } from './config';
import utils from '@/components/utils/common.js';
import store from '@/store';
import _ from 'lodash';
import lotsButton from '@/components/lots/lotsButton';
import columnConfig from '@/components/lots/columnConfig/Index';

import Paper from '@/components/core/Paper';
import lotsPagination from '@/components/lots/lotsPagination/Index';
import listLayoutPaper from '@/components/lots/listLayout/Paper';
import searchBox from '@/components/lots/searchBox';
import tableBox from '@/components/lots/tableBox/Index';
import reportExport from '@/components/lots/reportExportPlugin';
export default {
    name: 'failList',
    components: {
        Paper,
        listLayoutPaper,
        searchBox,
        tableBox,
        lotsPagination,
        lotsButton,
        columnConfig,
        reportExport
    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const tenantCode = store.getters.currentTenant.tenantCode;
        class ApiFailClass extends AdvanceListClass {
            beforeGetList(condition) {
                return searchDataFormat(condition);
            };
            afterGetList (res) {
                if (+res.code === 0) {
                    this.totalData.value = res.data.list;
                    this.pageTotal.value = res.data.totalCount;
                }
            };
        }
        const ApiFailList = new ApiFailClass({
            Api: {
                listApi: failRecordList // 查询接口
            }
        });
        const searchDataFormat = (condition) => {
            Object.keys(condition).forEach(v => {
                if (condition[v] === undefined || condition[v] === null || condition[v] === '') {
                    delete condition[v];
                }
            });
            return condition;
        };
        const config = reactive(configStatic);
        const refresh = () => {
            ApiFailList.getList();
        };

        const otpColumnConfig = ref(null);
        const showColumnConfigDialog = () => {
            otpColumnConfig.value.show(true);
        };
        const handleExport = async(submit) => {
            await setupContext.refs.searchBox.submitSearch(); // 解决输入参数不生效问题
            const { value } = ApiFailList.searchModel;
            const newData = _.cloneDeep(value); // 解决搜索参数被清空的问题
            const params = {
                ...searchDataFormat(newData),
                tenantCode,
                exportFlag: '1' // 跳过校验参数为空的情况
            };
            submit(params);
        };
        onMounted(() => {
            ApiFailList.getList();
        });
        return {
            ApiFailList,
            config,
            refresh,
            otpColumnConfig,
            showColumnConfigDialog,
            tenantCode,
            utils,
            handleExport
        };
    }
};
</script>
<style lang="less">
.fail-manage {
    width: 100%;
    .fail-manage-paper {
        height: 100%;
    }
    .list-layout-wrapper {
        height: 100%;
    }
    .fail-list-tab-pane.el-tabs {
        width: 100%;
        height: 100%;
        & > .el-tabs__content {
            height: calc(100% - 40px - 14px);
            overflow: auto;
            & > .el-tab-pane {
                overflow: auto;
                padding-right: 5px;
                height: 100%;
                .list-main {
                    .table-box {
                        height: 100%;
                    }
                }
            }
        }
    }
    .flex-layout .list-main {
        overflow: auto;
    }

    .flex-layout .table {
        overflow-y: auto;
    }
    .list-header {
        .fail-manage-list-dropdown.el-dropdown {
            color: #fff;
        }
    }

    .layout-content.fail-manage-paper {
        .layout-content{
            box-shadow:none!important;
        }
        .el-table .cell.el-tooltip {
            &>div {
                width: 100%;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
    }

    .list-layout-wrapper {
        padding: 0px;
    }
}
.fail-manage-list-dropdown-menu {
    background-color: #fff;
}
.column-config_title {
    font-size: 14px;
}
</style>
